export default "__VITE_ASSET__01ea7a15__"